/**
 * Theme-safe pastel metric tile classes for light + dark mode.
 * Use these instead of bare bg-*-50 / text-*-800 so dark mode stays readable.
 */
export const metricTile = {
  green: {
    surface:
      'rounded-lg border border-green-200/80 bg-gradient-to-br from-green-50 to-green-100 dark:border-green-800/60 dark:from-green-950/80 dark:to-green-900/50',
    icon: 'text-green-600 dark:text-green-400',
    value: 'text-green-800 dark:text-green-300',
    label: 'text-green-700 dark:text-green-400',
    badge:
      'text-green-700 dark:text-green-400 border-green-300 dark:border-green-700',
  },
  blue: {
    surface:
      'rounded-lg border border-blue-200/80 bg-gradient-to-br from-blue-50 to-blue-100 dark:border-blue-800/60 dark:from-blue-950/80 dark:to-blue-900/50',
    icon: 'text-blue-600 dark:text-blue-400',
    value: 'text-blue-800 dark:text-blue-300',
    label: 'text-blue-700 dark:text-blue-400',
    badge:
      'text-blue-700 dark:text-blue-400 border-blue-300 dark:border-blue-700',
  },
  purple: {
    surface:
      'rounded-lg border border-purple-200/80 bg-gradient-to-br from-purple-50 to-purple-100 dark:border-purple-800/60 dark:from-purple-950/80 dark:to-purple-900/50',
    icon: 'text-purple-600 dark:text-purple-400',
    value: 'text-purple-800 dark:text-purple-300',
    label: 'text-purple-700 dark:text-purple-400',
    badge:
      'text-purple-700 dark:text-purple-400 border-purple-300 dark:border-purple-700',
  },
  yellow: {
    surface:
      'rounded-lg border border-yellow-200/80 bg-gradient-to-br from-yellow-50 to-yellow-100 dark:border-yellow-800/60 dark:from-yellow-950/80 dark:to-yellow-900/50',
    icon: 'text-yellow-700 dark:text-yellow-400',
    value: 'text-yellow-800 dark:text-yellow-300',
    label: 'text-yellow-700 dark:text-yellow-400',
    badge:
      'text-yellow-700 dark:text-yellow-400 border-yellow-300 dark:border-yellow-700',
  },
  orange: {
    surface:
      'rounded-lg border border-orange-200/80 bg-gradient-to-br from-orange-50 to-orange-100 dark:border-orange-800/60 dark:from-orange-950/80 dark:to-orange-900/50',
    icon: 'text-orange-600 dark:text-orange-400',
    value: 'text-orange-800 dark:text-orange-300',
    label: 'text-orange-700 dark:text-orange-400',
    badge:
      'text-orange-700 dark:text-orange-400 border-orange-300 dark:border-orange-700',
  },
  red: {
    surface:
      'rounded-lg border border-red-200/80 bg-gradient-to-br from-red-50 to-red-100 dark:border-red-800/60 dark:from-red-950/80 dark:to-red-900/50',
    icon: 'text-red-600 dark:text-red-400',
    value: 'text-red-800 dark:text-red-300',
    label: 'text-red-700 dark:text-red-400',
    badge:
      'text-red-700 dark:text-red-400 border-red-300 dark:border-red-700',
  },
} as const;

export type MetricTileTone = keyof typeof metricTile;
